<template>
  <div class="app-main-inner">
    <div style="width: fit-content;">
      <div class="section">
        <el-form>
          <el-checkbox v-model="form.booking" no="booking" :disabled="readonly">{{ $t('SeaExport.Booking') }}</el-checkbox>
          <el-checkbox
            v-model="form.customs"
            no="customs"
            :disabled="readonly"
            style="margin-left: -20px;"
            @change="val=>{form.customsBroker=val?form.customsBroker:0;form.customsDeclarationType=val?form.customsDeclarationType:-1}"
          >{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
          <el-checkbox v-model="form.insure" :disabled="readonly" no="isInsure" style="margin-left: -20px;">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
          <el-checkbox v-if="isBookingNew && isFba" v-model="form.destinationPortService" no="destinationPortService" style="margin-left: -20px;">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
          <el-button
            v-if="viewSource==='bookingWorkspace'"
            v-permission="['button_insurance_toInsure']"
            no="Insure"
            :disabled="isEdit"
            type="primary"
            style="margin-left: 20px;"
            @click="pm.toInsure()"
          >{{ $t('SeaExport.Insure') }}</el-button>
          <span v-if="!isFba" style="margin-left: 20px;">{{ $t('CargoMsg.Cargo_BusinessType') }}</span>
          <el-radio-group v-if="!isFba" v-model="form.lob" no="lob" :disabled="readonly" style="margin-left: 10px;" @change="lobChangeHandler">
            <el-radio no="RE" label="RE">{{ $t('CargoMsg.Cargo_Export') }}</el-radio>
            <el-radio no="RI" label="RI" style="margin-left: -20px;">{{ $t('CargoMsg.Cargo_JobTypeImport') }}</el-radio>
          </el-radio-group>
        </el-form>
      </div>
      <div style="display: flex">
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="120px" label-position="right">

            <span class="title">{{ $t('SeaExport.BookingInfo') }}</span>
            <el-form-item :label="$t('SeaExport.BusinessNo')">
              <el-input :value="form.jobNo" no="jobNo" :disabled="true" />
            </el-form-item>
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  filterable
                  no="allowSaleProduct"
                  clearable
                  :data-filter-function="p => {
                    if (!p.statusEnabled) {
                      return false
                    }
                    return isFba ? p.fbaRailway : p.railwayFreight
                  }"
                  :default-value="form.saleProductCode || ''"
                  @parentCallBack="p => {form.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  no="fullOrInside"
                  clearable
                  :default-value="form.fullOrInside || ''"
                  @parentCallBack="p => {form.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <el-form-item :label="$t('RailwayExport.containerLoadType')">
              <el-select
                v-model="form.containerLoadType"
                no="containerLoadType"
                @change="pm.selectDefaultCutomJobType();onContainerLoadTypeChange()"
              >
                <el-option
                  v-for="(item,index) in containerLoadTypes"
                  :key="index"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoType')">
              <cargo-advance-select
                no="cargoType"
                :select-type="selectTypeNames.basic_data_CargoType"
                :headers="[$t('Partners.chineseName')]"
                :fields="['chineseName']"
                :filter-field-names="['chineseName']"
                :method-params="{sea:true}"
                filterable
                :clearable="false"
                :default-value="form.cargoType"
                @parentCallBack="p=>{form.cargoType=p.value;onCargoTypeChagne()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('RailwayExport.transportType') }}</span>
              <cargo-advance-select
                no="transportType"
                :select-type="selectTypeNames.basic_data_TransportationType"
                :method-params="{companyLob:'railwayExport',transportType:true,active:true}"
                filterable
                :default-value="form.transportType"
                :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                :tag-value="'code'"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="p=>{form.transportType=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('RailwayExport.fullHalf') }}</span>
              <cargo-advance-select
                no="fullHalf"
                :select-type="selectTypeNames.local_cache_FullHalf"
                filterable
                :default-value="form.fullHalf"
                @parentCallBack="p=>{form.fullHalf=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('RailwayExport.transportLine') }}</span>
              <cargo-advance-select
                no="transportLine"
                :select-type="selectTypeNames.basic_data_RailwayLine"
                filterable
                :default-value="form.transportLine"
                tag-name="name"
                @parentCallBack="p=>{form.transportLine=p.value;pm.refreshPlanner(p.value)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('RailwayExport.ETD2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.etd"
                  no="etd"
                  class="departure-date-picker"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="flex: 1; width:140px; margin-right: 5px"
                  @input="etdChange"
                />
                <span>{{ form.sailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.ETA2')">
              <span v-if="form.lob === 'RI'" slot="label" class="blue">
                {{ $t('RailwayExport.ETA2') }}
              </span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.eta"
                  no="eta"
                  type="date"
                  value-format="yyyy-MM-dd"
                  style="flex: 1; width:140px; margin-right: 5px"
                  @input="etaChange"
                />
                <span>{{ form.etaSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('RailwayExport.ATD2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.atd"
                  no="atd"
                  type="date"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="flex: 1; width:140px; margin-right: 5px"
                  @input="atdChange"
                />
                <span>{{ form.atdSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('RailwayExport.ATA2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  v-model="form.ata"
                  no="ata"
                  type="date"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="flex: 1; width:140px; margin-right: 5px"
                  @input="ataChange"
                />
                <span>{{ form.ataSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationDate')">
              <el-date-picker
                v-model="form.customsDate"
                no="customsDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('RailwayExport.departureStation') }}</span>
              <div style="display: flex">
                <cargo-advance-select
                  no="departureStation"
                  :select-type="selectTypeNames.basic_data_RailwayStation"
                  filterable
                  :default-value="form.departureStation"
                  @parentCallBack="p=>{form.departureStation=p.value;onDepartureStationChange()}"
                />
                <el-checkbox
                  v-model="form.transfer"
                  no="transfer"
                  style="width:80px; padding-left: 5px;"
                >{{ $t('SeaExport.Transit') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item
              v-show="form.transfer"
            >
              <span slot="label" class="blue">{{ $t('RailwayExport.transferStation') }}</span>
              <cargo-advance-select
                no="transferStation"
                :select-type="selectTypeNames.basic_data_RailwayStation"
                filterable
                :default-value="form.transferStation"
                @parentCallBack="p=>{form.transferStation=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('RailwayExport.transitStation') }}</span>
              <cargo-advance-select
                no="transitStation"
                :select-type="selectTypeNames.basic_data_RailwayStation"
                filterable
                :default-value="form.transitStation"
                @parentCallBack="p=>{form.transitStation=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('RailwayExport.destinationStation') }}</span>
              <cargo-advance-select
                no="destinationStation"
                :select-type="selectTypeNames.basic_data_RailwayStation"
                filterable
                :default-value="form.destinationStation"
                @parentCallBack="destinationStationChange"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.destinationCountry')">
              <cargo-advance-select
                no="destinationCountry"
                :select-type="selectTypeNames.basic_data_Country"
                filterable
                :default-value="form.destinationCountry"
                @parentCallBack="p=>{form.destinationCountry=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <el-select
                v-model="form.cargoSource"
                no="cargoSource"
                :placeholder="$t('SeaExport.PleaseSelect')"
                :clearable="false"
                size="mini"
                @change="form.designationAgent=0;pm.cargoSourceChange()"
              >
                <el-option
                  v-for="(item,index) in CARGO_SOURCES"
                  :key="index"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                v-if="form.lob==='RE'"
                key="1"
                ref="customJobType"
                no="customJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :default-value="form.customJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="customJobTypeList"
                :method-params="{type:form.lob}"
                @parentCallBack="p=>{form.customJobType=p.value;onCustomJobTypeChange()}"
              />
              <cargo-advance-select
                v-else-if="form.lob==='RI'"
                key="2"
                ref="customJobType"
                no="customJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :tag-name="isZh?'name':'englishName'"
                :static-options="customJobTypeList"
                :method-params="{type:form.lob}"
                :default-value="form.customJobType"
                @parentCallBack="p=>{form.customJobType=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="form.customJobType && secondaryCustomJobTypeList.length > 0" :label="$t('CargoMsg.Cargo_Grade')">
              <cargo-advance-select
                ref="secondaryCustomJobType"
                no="secondaryCustomJobType"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :cache="false"
                :default-value="form.secondaryCustomJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="secondaryCustomJobTypeList"
                @parentCallBack="p=>{form.secondaryCustomJobType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                no="bookingAgent"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{companyLob:'railwayExport',bookingAgent:true,active:true}"
                filterable
                :default-value="form.bookingAgent||''"
                @parentCallBack="p=>{form.bookingAgent=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.portAgent')">
              <cargo-advance-select
                no="portAgent"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{companyLob:'railwayExport',portAgent:true,active:true}"
                filterable
                :default-value="form.portAgent||''"
                @parentCallBack="p=>{form.portAgent=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.forwardingAgent')">
              <cargo-advance-select
                no="forwardingAgent"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{companyLob:'railwayExport',forwardingAgent:true,active:true}"
                filterable
                :default-value="form.forwardingAgent||''"
                @parentCallBack="p=>{form.forwardingAgent=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.destinationAgent')">
              <el-tooltip
                :content="destinationAgentTip"
                :disabled="!showDestinationAgentWarning"
                placement="right-end"
              >
                <cargo-company-select
                  ref="destinationAgent"
                  no="destinationAgent"
                  :method-params="{overseaAgent:true,active:true,companyLob:'railwayExport'}"
                  :check-credit="true"
                  :job="form"
                  :default-value="form.destinationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"

                  @change="p=>{pm.txtDestinationAgentChangeHandler(p)}"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item
              v-show="form.cargoSource==='NC'"
              :label="$t('SeaExport.NominatedAgent')"
            >
              <span slot="label" class="blue">
                {{ $t('SeaExport.NominatedAgent') }}
              </span>
              <el-tooltip
                :content="designationAgentTip"
                :disabled="!showDesignationAgentWarning"
                placement="right-end"
              >
                <cargo-company-select
                  no="designationAgent"
                  class="designation-agent-selector"
                  popper-class="designation-agent-selector-popper"
                  :disabled="!designationAgentEnabled"
                  :method-params="{designationAgent:true,active:true}"
                  :check-credit="true"
                  :job="form"
                  :default-value="form.designationAgent||''"
                  filterable
                  :headers="[$t('Partners.englishName')]"
                  :fields="['englishName']"
                  tag-name="englishName"
                  style="width:190px;"
                  @change="p=>{pm.txtDesignationAgentChangeHandler(p)}"
                />
              </el-tooltip>
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TransportSource')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_TransportSource"
                no="transportSource"
                :default-value="form.transportSource"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>form.transportSource=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ServiceStatisticalArea')">
              <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_StatisticArea"
                no="statisticArea"
                :default-value="form.statisticArea"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>form.statisticArea=item.value"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('RailwayExport.ServiceChannel')">
              <el-input v-model="fbaJob.serviceChannel" />
            </el-form-item>
          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="110px" label-position="right">

            <span class="title">{{ $t('SeaExport.AdditionalInformation') }}</span>
            <el-form-item :label="$t('SeaExport.LocalService')">
              <el-checkbox
                v-model="form.warehousing"
                no="warehousing"
                @change="pm.loadingTermChange('warehousing')"
              >{{ $t('SeaExport.WarehouseLoadingStorage') }}</el-checkbox>
              <el-checkbox
                v-model="form.landTransportation"
                no="landTransportation"
                @change="pm.loadingTermChange('landTransportation')"
              >{{ $t('SeaExport.DoorLoadingDelivery') }}</el-checkbox>
              <el-checkbox
                v-model="form.selfDeliver"
                no="selfDeliver"
              >{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}</el-checkbox>
            </el-form-item>
            <el-form-item v-if="isBookingNew && form.destinationPortService" :label="$t('SeaExport.PortOfDestinationServices')">
              <el-checkbox
                v-model="form.dischargingPortDoor"
                no="dischargingPortDoor"
                style="display: block;"
              >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
              </el-checkbox>
              <el-checkbox
                v-model="form.usCustomsClearance"
                no="usCustomsClearance"
                style="display: block;"
              >{{ $t('queryJob.UsCustomsClearance') }}
              </el-checkbox>
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('SeaExport.WarehouseNo')">
              <el-input v-model="form.warehouseNo" no="warehouseNo" style="margin-bottom: 10px;" />
              <!-- 无效的按钮（和cargo保持一致，暂不移除） -->
              <el-button
                :disabled="true"
                no="ObtainTheWarehouseNo"
                type="primary"
                style="padding-left:13px;padding-right:13px;"
              >{{ $t('SeaExport.ObtainTheWarehouseNo') }}</el-button>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('RailwayExport.paymentMethod') }}</span>
              <cargo-advance-select
                no="paymentMethod"
                :select-type="selectTypeNames.basic_data_PaymentMethod"
                :method-params="{companyLob:'railwayExport',paymentMethod:true,active:true}"
                filterable
                :default-value="form.paymentMethod"
                :tag-name="this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'"
                :tag-value="'code'"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="p=>{form.paymentMethod=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.mbl')">
              <el-input v-model="form.mbl" no="mbl" />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.vessel')">
              <el-input v-model="form.vessel" no="vessel" />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.voyageFlight')">
              <el-input v-model="form.voyageFlight" no="voyageFlight" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BusinessReferenceNo')">
              <cargo-input v-model="form.customerRefNo" no="customerRefNo" :trim="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'poNoClass':''">
              <el-input v-model="form.poNo" no="poNo" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsBroker')">
              <cargo-advance-select
                no="customsBroker"
                :disabled="!customsBrokerEnabled"
                style="width:190px;"
                :method-params="{customsBroker:true}"
                :select-type="selectTypeNames.basic_data_Company"
                :data-filter-function="customsBrokerFilter"
                filterable
                :default-value="form.customsBroker||''"
                :placeholder="form.customs?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseTickCustomsDeclarationOption')"
                @parentCallBack="p=>{pm.customsBrokerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="!isFba" :label="$t('SeaExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethod"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:2}"
                tag-value="serialNum"
                filterable
                :default-value="form.customClaim"
                @parentCallBack="p=>{form.customClaim=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationType')">
              <cargo-advance-select
                no="customsDeclarationType"
                :disabled="!customsBrokerEnabled"
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                filterable
                :default-value="form.customsDeclarationType===-1?'':form.customsDeclarationType"
                :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{form.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="tradeTerm"
                filterable
                :select-type="selectTypeNames.basic_data_TradeTerm"
                callback-method-type="value"
                :default-value="form.tradeTerm"
                :callback-params="{key:'tradeTerm'}"
                @parentCallBack="p=>{form.tradeTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="incoTerm"
                filterable
                :clearable="false"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                callback-method-type="value"
                :default-value="form.incoTerm"
                :callback-params="{key:'incoTerm'}"
                placeholder=" "
                @parentCallBack="p=>{form.incoTerm=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.HaulageCompany')">
              <cargo-company-select
                no="carryingCmp"
                :disabled="!form.landTransportation"
                :method-params="{truckCmp:true,active:true}"
                :default-value="form.carryingCmp||''"
                :placeholder="form.landTransportation?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"
                @change="p=>{pm.carryingCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('Information.TransportationTerms')">
              <cargo-advance-select
                no="freightTerm"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                filterable
                :clearable="false"
                :default-value="form.freightTerm"
                @parentCallBack="p=>{form.freightTerm=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('RailwayExport.EstimatedStoragegoodReadyTime')">
              <el-date-picker
                v-model="fbaJob.preWarehousingTime"
                no="preWarehousingTime"
                type="date"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
              />
            </el-form-item>
            <el-form-item :label="isFba ? $t('RailwayExport.DomesticWarehouse') : (openWarehouse ? $t('SeaExport.WarehouseSupplier') : $t('SeaExport.Warehouse'))">
              <cargo-company-select
                no="warehouseCmp"
                :disabled="!warehouseEabled"
                :method-params="{warehouse:true,active:true}"
                :default-value="form.warehouseCmp||''"
                :placeholder="form.warehousing?$t('CargoMsg.Cargo_keyWordsTip'):$t('SeaExport.PleaseSelectWarehouse')"
                @change="p=>{pm.warehouseCmpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-if="openWarehouse && !isFba" :label="$t('SeaExport.WareHouseName')">
              <el-select
                ref="warehouseName"
                v-model="form.warehouseName"
                no="warehouseName"
                :disabled="!warehouseEabled||!form.warehouseCmp"
                :allow-create="true"
                filterable
                :clearable="true"
                @change="warehouseNameChangeHandler"
              >
                <el-option
                  v-for="(item,index) in warehouseNameList"
                  :key="index"
                  :label="item.warehouseName"
                  :value="item.warehouseName"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('RailwayExport.OverseasWarehouse')">
              <cargo-advance-select
                no="overseaWarehouseCode"
                :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                filterable
                :method-params="{ifFba:false}"
                :clearable="false"
                tag-name="countryChineseName"
                tag-value="warehouseCode"
                :default-value="form.overseaWarehouseCode"
                style="width:100%;"
                @parentCallBack="p=>{form.overseaWarehouseCode=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('RailwayExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethodPol"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:0}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPol"
                @parentCallBack="p=>{fbaJob.customsMethodPol=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="isFba" :label="$t('RailwayExport.CustomsClearanceMethod')">
              <cargo-advance-select
                no="customsMethodPod"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:1}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPod"
                @parentCallBack="p=>{fbaJob.customsMethodPod=p.value}"
              />
            </el-form-item>
            <el-checkbox
              v-model="form.diffPlacesCollaborate"
              no="diffPlacesCollaborate"
            >{{ $t('RailwayExport.isDiffPlacesCollaborate') }}</el-checkbox>
            <el-form-item :label="$t('RailwayExport.loadingPlaceCompany')">
              <cargo-company-select
                no="loadingPlaceCompany"
                :method-params="{companyLob:'railwayExport',loadingPlaceCompany:true,active:true}"
                :check-credit="true"
                :job="form"
                :tooltip="true"
                tooltip-tag-name="englishName"
                :default-value="form.loadingPlaceCompany||''"
                @change="p=>{form.loadingPlaceCompany=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.signBillPlaceCompany')">
              <cargo-company-select
                no="signBillPlaceCompany"
                :method-params="{companyLob:'railwayExport',signBillPlaceCompany:true,active:true}"
                :check-credit="true"
                :job="form"
                :tooltip="true"
                tooltip-tag-name="englishName"
                :default-value="form.signBillPlaceCompany||''"
                @change="p=>{form.signBillPlaceCompany=p.value}"
              />
            </el-form-item>
            <el-checkbox v-model="form.fullShipment">{{ $t('RailwayExport.isFullShipment') }}</el-checkbox>
            <el-form-item :label="$t('RailwayExport.dischargePortCompany')">
              <cargo-company-select
                no="dischargePortCompany"
                :method-params="{companyLob:'railwayExport',dischargePortCompany:true,active:true}"
                :check-credit="true"
                :job="form"
                :tooltip="true"
                tooltip-tag-name="englishName"
                :default-value="form.dischargePortCompany||''"
                @change="p=>{form.dischargePortCompany=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.destinationPortCompany')">
              <cargo-company-select
                no="destinationPortCompany"
                :method-params="{companyLob:'railwayExport',destinationPortCompany:true,active:true}"
                :check-credit="true"
                :job="form"
                :tooltip="true"
                tooltip-tag-name="englishName"
                :default-value="form.destinationPortCompany||''"
                @change="p=>{form.destinationPortCompany=p.value}"
              />
            </el-form-item>

          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="right">

            <span class="title">{{ $t('SeaExport.ContainerInfo2') }}</span>
            <el-form-item label-width="0" class="auto-width">
              <booking-sea-eq-data-grid
                :value="seaEqList"
                :container-load-type="form.containerLoadType"
                :hide-soc="true"
                :is-edit="isEdit"
                :job="form"
                style="width:100%"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.QuantityConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.quantityContract"
                  no="quantityContract"
                  :precision="0"
                  :min="0"
                  @change="SEUtils.changeQWCRule(()=>{form.quantityActual=form.quantityContract})"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  v-model="form.quantityActual"
                  no="quantityActual"
                  :precision="0"
                  :min="0"
                  @change="SEUtils.changeQWCRule(null,()=>{form.quantityContract=form.quantityActual})"
                />
                <span>PCS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WeightConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.weightContract"
                  no="weightContract"
                  :precision="3"
                  :min="0"
                  @change="weightContractChange"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  v-model="form.weightActual"
                  no="weightActual"
                  :precision="3"
                  :min="0"
                  @change="weightActualChange"
                />
                <span>KGS</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CubageConsignActual')">
              <div style="display: flex">
                <auto-number-input
                  v-model="form.cubageContract"
                  no="cubageContract"
                  :precision="3"
                  :disabled="!cubageActualEnabled"
                  :min="0"
                  @change="cubageContractChange"
                />
                <span style="padding:0 2px;">/</span>
                <auto-number-input
                  ref="cubageActual"
                  v-model="form.cubageActual"
                  no="cubageActual"
                  :precision="3"
                  :min="0"
                  @change="cubageActualChange"
                />
                <span>CBM</span>
              </div>
            </el-form-item>
            <el-form-item v-if="isFba" label-width="0">
              <div style="display: flex;justify-content: space-around">
                <el-checkbox v-model="fbaJob.electric" style="margin-right: 10px;margin-left: 20px;">{{ $t('RailwayExport.WithBattery') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.magnetic" style="margin-right: 10px;">{{ $t('RailwayExport.WithMagnet') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.powdery" style="margin-right: 10px;">{{ $t('RailwayExport.Powder') }}</el-checkbox>
                <el-checkbox v-model="fbaJob.liquid" style="margin-right: 10px;">{{ $t('RailwayExport.Liquid') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')">
              <cargo-packing-select
                ref="packing"
                no="packing"
                :default-value="form.packing"
                style="width:100%;"
                @change="p=>{form.packing=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.ChineseDescriptionOfGoods') }}</span>
                <el-button
                  v-show="isEdit"
                  no="MergingTickets"
                  type="primary"
                  @click="pm.mergeLclCargoDocInfo('cargoChineseName', form)"
                >{{ $t('SeaExport.MergingTickets') }}</el-button>
              </div>
              <cargo-rich-textarea
                v-model="form.cargoChineseName"
                no="cargoChineseName"
                :disabled="readonly"
                :auto-half-word="false"
                :text-chars="0"
                :class="form.cargoChineseNameWarning === 1 ? 'red-border' : ''"
                style="height: 70px;min-height: 70px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),form.cargoChineseName,true,val=>{form.cargoChineseName=val})"
              />
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.EnglishDescriptionOfGoods') }}</span>
                <el-button
                  v-show="isEdit"
                  no="MergingTickets2"
                  type="primary"
                  @click="pm.mergeLclCargoDocInfo('cargoEnglishName', form)"
                >{{ $t('SeaExport.MergingTickets') }}</el-button>
              </div>
              <cargo-rich-textarea
                v-model="form.cargoEnglishName"
                no="cargoEnglishName"
                :disabled="readonly"
                :text-chars="0"
                :auto-uppercase="isUppercaseByConfig"
                :class="form.cargoEnglishNameWarning === 1 ? 'red-border' : ''"
                style="height: 70px;min-height: 70px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),form.cargoEnglishName,isUppercaseByConfig,val=>{form.cargoEnglishName=val})"
              />
            </el-form-item>
            <el-form-item>
              <div slot="label">
                <span>{{ $t('SeaExport.Marks') }}</span>
                <el-button
                  v-show="isEdit"
                  no="MergingTickets3"
                  type="primary"
                  @click="pm.mergeLclCargoDocInfo('mark', form)"
                >{{ $t('SeaExport.MergingTickets') }}</el-button>
              </div>
              <cargo-rich-textarea
                v-model="form.mark"
                no="mark"
                :disabled="readonly"
                :text-chars="0"
                :auto-uppercase="isUppercaseByConfig"
                style="height: 70px;min-height: 70px;"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,isUppercaseByConfig,val=>{form.mark=val})"
              />
            </el-form-item>

          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="right">

            <span class="title">{{ $t('SeaExport.OperationInfo') }}</span>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.SalesCompany') }}</span>
              <el-input :value="txtSalesOffice" no="txtSalesOffice" :disabled="true" />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.Sales') }}</span>
              <cargo-user-select
                ref="sales"
                no="sales"
                :disbled="!canChangeSalesOfJob||pm.isWithinCloseAccountDate"
                :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                :default-value="form.sales||''"
                :merge-load="true"
                @change="p=>{pm.txtSalesChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="cargoSalesId"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="form.cargoSalesId||''"
                :merge-load="true"
                @change="p=>{form.cargoSalesId=p.value;pm.cargoSalesChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.SalesDepartment') }}</span>
              <cargo-department-new-select
                no="salesOffice"
                :disabled="!form.sales"
                :enables="true"
                :sales-id="Number(form.sales)"
                :office-id="form.salesOffice"
                :department-id="Number(form.salesDepartment)"
                @change="p=>{pm.departmentChargeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-office-select
                no="opOffice"
                :disabled="(!isRegionalCommission && pm.isEntrustOrder(true)) || opOfficeDisabled"
                :is-regional-commission="isRegionalCommission"
                :office-id="Number(form.opOffice)"
                @change="p=>{form.opOffice=p.value;form.opDepartment=0;opOfficeChargeHandler()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.OperationDepartment') }}</span>
              <cargo-department-select
                no="opDepartment"
                :disabled="pm.isWithinCloseAccountDate"
                :office-id="Number(form.opOffice)"
                :enables="true"
                :department-id="Number(form.opDepartment)"
                @change="p=>{form.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.Operation') }}</span>
              <cargo-user-select
                no="op"
                :disabled="!opEabled"
                :method-params="{officeId:form.opOffice,category:'role',shape:'op'}"
                :default-value="form.op||''"
                :merge-load="true"
                @change="p=>{pm.txtOPChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-office-select
                no="csrOffice"
                :disabled="true"
                :office-id="Number(form.csrOffice)"
                @change="p=>{form.csrOffice=p.value;form.csrDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Customer_Service') }}</span>
              <cargo-department-select
                no="csrDepartment"
                :office-id="Number(form.csrOffice)"
                :enables="true"
                :department-id="Number(form.csrDepartment)"
                @change="p=>{form.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                no="csr"
                :method-params="{officeId:pm.isEntrustOrder||fom.salesOffice===1?form.opOffice:form.salesOffice,category:'role',shape:'csr'}"
                :default-value="form.csr||''"
                :merge-load="true"
                @change="p=>{pm.csrChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                :method-params="{officeId:form.opOffice,category:'role',shape:'siteOp'}"
                :default-value="form.siteOP||''"
                @change="p=>{JobUtils.siteOpChangeHandler(form, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                no="overseaOp"
                :method-params="{category:'role',shape:'overseaOp'}"
                :default-value="form.overseaOp||''"
                :static-options="isHC ? null : overseaOpList"
                :merge-load="true"
                @change="p=>{pm.overseaOpChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')">
              <cargo-office-select
                no="dcOffice"
                :disabled="true"
                :office-id="Number(form.dcOffice)"
                @change="p=>{form.dcOffice=p.value;form.dcDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('Message.Documentation_Department') }}</span>
              <cargo-department-select
                no="dcDepartment"
                :office-id="Number(form.dcOffice)"
                :enables="true"
                :department-id="Number(form.dcDepartment)"
                @change="p=>{form.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select
                no="dc"
                :method-params="{officeId:form.opOffice,category:'role',shape:'doc'}"
                :default-value="form.dc||''"
                :merge-load="true"
                @change="p=>{pm.dcChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.plannerOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(form.plannerOffice)"
                @change="p=>{form.plannerOffice=p.value;form.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('RailwayExport.plannerDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :office-id="Number(form.plannerOffice)"
                :enables="true"
                :department-id="Number(form.plannerDepartment)"
                @change="p=>{form.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('RailwayExport.planner')">
              <cargo-user-select
                no="planner"
                :method-params="{category:'role',shape:'railwayLine'}"
                :default-value="form.planner||''"
                :merge-load="true"
                @change="p=>{pm.txtPlannerChangeHandler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="form.userDefinedRoleId1||''"
                :merge-load="true"
                @change="p=>{pm.userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="form.userDefinedRoleId2||''"
                :merge-load="true"
                @change="p=>{pm.userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.WarehousingInfo')">
              <el-input no="txtWhs" :disabled="true" type="textarea" :rows="4" :value="txtWhs" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')">
              <el-input
                v-model="form.remarks"
                no="remarks"
                type="textarea"
                :rows="4"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),form.remarks,false,val=>{form.remarks=val})"
              />
            </el-form-item>

          </el-form>
        </div>
        <div class="section form-column">
          <el-form :disabled="readonly" label-width="100px" label-position="right">

            <span class="title">{{ $t('SeaExport.UserDefinedArea') }}</span>
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input v-model="form.userDefinedField1" no="userDefinedField1" type="textarea" :rows="5" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input v-model="form.userDefinedField2" no="userDefinedField2" type="textarea" :rows="5" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input v-model="form.userDefinedField3" no="userDefinedField3" type="textarea" :rows="5" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input v-model="form.userDefinedField4" no="userDefinedField4" type="textarea" :rows="5" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="form.taxNature"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="form-card-wrapper" style="display:flex;flex-direction: row;width: 100%">
        <div class="section form-column" style="flex:1">

          <span class="title">{{ $t('SeaExport.TicketsInfo') }}</span>
          <div
            style="display:flex;justify-content: flex-start;margin-bottom: 5px;line-height: 28px;"
          >
            <span>{{ $t('SeaExport.TotalTickets') }}:</span>
            <span style="margin-right: 5px;">{{ lclSlaves.length }}</span>
            <div v-show="readonly&&viewSource==='bookingWorkspace'" class="triggers">
              <el-button
                no="NewTickets"
                :disabled="viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnCreateClickHandler"
              >{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button
                no="EditTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnLcLEditClickHandler"
              >{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button
                no="AddTickets"
                :disabled="viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="primary"
                @click="btnImportLclClickHandler"
              >{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button
                no="RemoveTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="danger"
                @click="pm.btnBatchRemoveClickHandler()"
              >{{ $t('SeaExport.RemoveTickets') }}</el-button>
              <el-button
                v-permission="['button_REBooking_deleteSmallTicket']"
                no="DeleteTickets"
                :disabled="!selectedRow || viewSource === 'financeDetail' || viewSource === 'salesDetail'"
                type="danger"
                @click="btnRemoveClickHandler"
              >{{ $t('SeaExport.DeleteTickets') }}</el-button>
            </div>
          </div>
          <div style="min-height: 200px;flex-direction: column">
            <cargo-ag-grid
              config-module="170003"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="lclSlaves"
              style="height: 300px;"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>

        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="advanceText"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :warning-count="-1"
        :text-chars="0"
        :auto-uppercase="advanceTextDialog.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="confirm"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 票数填写弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="ticket"
      :visible.sync="ticketDialog.visible"
      :title="$t('SeaExport.FillInQuantityOfVotes')"
      width="270px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="50px" label-position="right">
        <el-form-item :label="$t('SeaExport.Number')+'：'">
          <el-input-number
            v-model="ticketDialog.value"
            :precision="0"
            :min="1"
            :max="50"
            :controls="false"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="confirm" type="primary" @click="toAddTicket">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="cancel" type="primary" @click="ticketDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-re-lcl-dialog
      :visible.sync="queryRELclDialog.visible"
      :job="form"
      @callback="rows=>{pm.slavedAddedHandler(rows)}"
    />
  </div>
</template>

<script>
import { TabBookingMasterPM } from './tabBookingMasterPM'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import queryReLclDialog from '../queryRELclDialog'
import lang from '@/lang'
import { formatNumberToThousands } from '@/utils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ErrorTip } from '@/utils/class/ErrorTip'
import ColumnUtils from '@/utils/ColumnUtils'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { CONTAINERLOAD_TYPES_LCL } from '@/class/cargo/model/parameters/ContainerLoadType'
import {
  CARGO_SOURCES, EXPORT_CONTROLLED_PRODUCT,
  LOG_RE_RAILWAY_BOOKING,
  RATE_TYPE,
  TAX_NATURES
} from '@/class/cargo/model/parameters/SystemConstants'
import { PAYMENTMETHOD_TYPES } from '@/class/cargo/model/parameters/PaymentMethod'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { checkPoNoIsExist, validateDelJob } from '@/api/booking/job'
import { getLoading } from '@/utils/utilBaseElement'
import { multiply, mergeArray } from '@/utils/commonUtil'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { FbaJob } from '@/class/model/booking/FbaJob'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import cargoInput from '@/components/Cargo/Common/cargoInput.vue'
import { PrintTemplateUtil } from '@/class/cargo/model/utils/PrintTemplateUtil'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'ReTabBookingMaster',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE': return lang.t('SeaExport.TUE')
        case 'WED': return lang.t('SeaExport.WED')
        case 'THU': return lang.t('SeaExport.THU')
        case 'FRI': return lang.t('SeaExport.FRI')
        case 'SAT': return lang.t('SeaExport.SAT')
        case 'SUN': return lang.t('Pricing.Sun')
        case 'MON':
        default: return lang.t('SeaExport.MON')
      }
    }
  },
  components: {
    cargoInput,
    cargoAdvanceSelect, cargoDepartmentNewSelect, cargoDepartmentSelect, cargoUserSelect, cargoCompanySelect, cargoPackingSelect,
    cargoOfficeSelect, cargoRichTextarea, bookingSeaEqDataGrid, queryReLclDialog, AutoNumberInput
  },
  mixins: [BasicTabMixin],
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    viewSource: { type: String, default: '' },
    cooperateEdit: { type: Boolean, default: true }, // 能否修改
    isFba: { type: Boolean, default: false } // 是否是FBA业务
  },
  data() {
    return {
      pm: new TabBookingMasterPM(this),
      selectTypeNames: TYPE_NAMES,
      containerLoadTypes: CONTAINERLOAD_TYPES_LCL,
      CARGO_SOURCES,
      TAX_NATURES,
      EXPORT_CONTROLLED_PRODUCT,
      rateType: RATE_TYPE,
      PAYMENTMETHOD_TYPES,
      SEUtils,
      salesOfficeCheck: false, // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
      canChangeSalesOfJob: false,
      isHC: false,
      form: new RailwayExportJob().fillDefaultValue().getData(),
      fbaJob: new FbaJob().fillDefaultValue().getData(), // fbaJob
      showDesignationAgentWarning: false,
      designationAgentTip: '',
      txtSalesOffice: '', // 销售所在分公司
      overseaOpList: null,
      txtWhs: '', // 入库信息
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: event => {
          // 清除单选行
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        onCellDoubleClicked: event => {
          this.btnLcLEditClickHandler(event)
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 150
        }, {
          headerName: this.$t('SeaExport.WarehouseNo'),
          field: 'warehouseNo',
          width: 150
        }, {
          headerName: this.$t('RailwayExport.mbl'),
          field: 'mbl',
          width: 120
        }, {
          headerName: this.$t('SeaExport.ConsignationCompany'),
          field: 'customerId',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('RailwayExport.transitStation'),
          field: 'transitStation',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        }, {
          headerName: this.$t('RailwayExport.destinationStation'),
          field: 'destinationStation',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
          }
        }, {
          headerName: this.$t('RailwayExport.ETD'),
          field: 'etd',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
          }
        }, {
          headerName: this.$t('SeaExport.ChineseDescriptionOfGoods'),
          field: 'cargoChineseName',
          width: 120
        }, {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          field: 'cargoEnglishName',
          width: 120
        }, {
          headerName: this.$t('SeaExport.ActualQuantity'),
          field: 'quantityActual',
          width: 120,
          cellRenderer: params => {
            return formatNumberToThousands(ColumnUtils.numberColumnLabelFunc(params.value))
          }
        }, {
          headerName: this.$t('SeaExport.ActualWeight'),
          field: 'weightActual',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ActualVolume'),
          field: 'cubageActual',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.ChargedWeight'),
          field: 'chargeWeight',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.number3ColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Shipper'),
          colId: 'shipperLine1',
          field: 'shipperLine1',
          hide: true,
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_Consignee'),
          colId: 'consigneeLine1',
          field: 'consigneeLine1',
          hide: true,
          width: 120
        }
      ],
      gridApi: null,
      selectedNode: null,
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        autoUppercase: false,
        successCallback: null
      },
      ticketDialog: {
        visible: false,
        value: 0
      },
      queryRELclDialog: {
        visible: false
      },
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      openWarehouse: false,
      warehouseNameList: [],
      opEabled: false,
      JobUtils,
      showDestinationAgentWarning: false,
      destinationAgentTip: '',
      poNoRed: false,
      needConfirmProjectNo: false,
      secondaryCustomJobTypeList: [],
      customJobTypeList: [],
      isZY: false, // 显示中邮选项
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    config() {
      return this.context.config
    },
    seaEqList() {
      return this.form.seaEQ || []
    },
    lclSlaves() {
      return this.form.lclSlaves || []
    },
    designationAgentEnabled() {
      return SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'designationAgent')
    },
    customsBrokerEnabled() {
      if (!this.form.customs) {
        return false
      }
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'customsBroker')) {
        return false
      }
      return true
    },
    warehouseEabled() {
      if (!this.form.warehousing) {
        return false
      }
      if (!SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'warehouseCmp')) {
        return false
      }
      return true
    },
    cubageActualEnabled() {
      return SecurityUtil.checkOffsetAutoCompleteEnabled(this.form, 'WCB')
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    },
    // 是否为铁路头程
    isBookingNew() {
      return this.$route.path.toLowerCase() === '/FBA/FBARailwayExport'.toLowerCase()
    },
    location() {
      if (!this.form.fba) {
        return LOG_RE_RAILWAY_BOOKING.code
      }
      return ''
    },
    // 销售分公司
    salesOffice() {
      return this.form.salesOffice
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!row.uuid) {
        row.booking = true
      }
      if (this.isEdit) {
        if (this.form.uuid) {
          this.opEabled = await SecurityUtil.canEdit(this.form, false)
        } else {
          this.opEabled = true
        }
      }
      this.setSecondaryCustomJobTypeFunc()
      if (!isRefresh) {
        return
      }
      /* ****************************** 初始化 begin ****************************** */
      this.isHC = String(cache.config.get('ToExoSystem')) === 'HC'
      this.salesOfficeCheck = Number(this.context.config.get('SalesOfficeCheck')) === 1
      this.canChangeSalesOfJob = Number(this.context.config.get('canChangeSalesOfJob')) === 1
      this.isAddUserDefinedRoles = Number(this.context.config.get('IsAddUserDefinedRoles')) === 1
      this.openWarehouse = Number(this.context.config.get('isOpenWarehouse')) > 0
      this.needConfirmProjectNo = Number(this.context.config.get('needConfirmProjectNo')) === 1
      this.isZY = String(this.context.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
      this.isUppercaseByConfig = Number(this.context.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
      this.overseaOpList = null
      /* ****************************** end ****************************** */
      this.form = row
      const railwayLines = getCacheListByKey(TYPE_NAMES.basic_data_RailwayLine)
      if (railwayLines.length > 0) {
        const index = railwayLines.findIndex(p => p.code === this.form.transportLine)
        if (index < 0) {
          this.form.transportLine = railwayLines[0].code
        }
      }
      this.pm.changeJob()
      this.pm.fillView()
      JobUtils.setSailingDay(this.form)

      // fba
      if (this.form.fba) {
        this.fbaJob = this.form.uuid ? this.form.fbaJob : new FbaJob().fillDefaultValue().getData()
      }
      if (!this.isEdit && this.form.poNo && this.needConfirmProjectNo) {
        checkPoNoIsExist(this.form.poNo, this.form.uuid).then(res => { this.poNoRed = (res.data > 0) })
      }
      if (this.isEdit) {
        this.setCustomJobTypeFunc()
      }
      JobUtils.getReceiptCharges(this.form)
      if (this.$store.getters.enableFrontEndPlugin) {
        this.setUserDefinedRoleDataUI()
      }
    },
    customJobTypeFilter(item, inputVal) {
      if (!item.active) {
        return false
      }
      if (item.type !== 'RE' && item.type !== 'RI') {
        return false
      }
      if (item.code === inputVal && this.form.lob === item.type) {
        return true
      }
      return this.form.lob === item.type
    },
    // 组装打印参数
    getPrintData() {
      const params = {}
      // params.jobuuid = this.form.uuid
      // params.JOB_UUID = this.form.uuid
      // params.REQUEST_UUID = ''
      PrintTemplateUtil.buildPrintDataByBookingRe(this.form, params)
      params.category = 'BOOKING_RE'
      params.ctx = new RailwayExportJob(this.form)
      return params
    },
    async etdChange(value) {
      this.form.etd = value
      this.pm.getSailingDay()
      console.log('==========>>>>>>lob', this.form.lob)
      if (this.form.lob === 'RE') {
        await ChargeUtils.updateETDFee(this.form, this.form.etd, this.context, true)
      }
      this.form.sailingDay = JobUtils.dateChange(this.form.etd)
    },
    async etaChange(value) {
      this.form.eta = value
      this.form.etaSailingDay = JobUtils.dateChange(this.form.eta)
      console.log('==========>>>>>>lob', this.form.lob)
      if (this.form.lob === 'RI') {
        await ChargeUtils.updateETDFee(this.form, this.form.eta, this.context, true)
      }
    },
    async atdChange(value) {
      this.form.atd = value
      this.form.atdSailingDay = JobUtils.dateChange(this.form.atd)
    },
    async ataChange(value) {
      this.form.ata = value
      this.form.ataSailingDay = JobUtils.dateChange(this.form.ata)
    },
    async weightContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshWeightCharge(this.form, this.form.weightContract)
      }
      await SEUtils.changeQWCRule(async() => {
        if (this.form.weightActual !== this.form.weightContract) {
          this.form.weightActual = this.form.weightContract
          if (ChargeUtils.getChargeWeightValueType(true) === 0) {
            await this.refreshWeightCharge(this.form, this.form.weightActual)
          }
        }
      })
    },
    async refreshWeightCharge(job, weight) {
      const charges = ChargeUtils.weightChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.WeightChangeToRefreshCostBasedOnWeightPrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = weight
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
      ChargeUtils.wgttWeightChargesCanUpdate(job, weight, this.context)
    },
    async weightActualChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.refreshWeightCharge(this.form, this.form.weightActual)
      }
      await SEUtils.changeQWCRule(null, async() => {
        if (this.form.weightContract !== this.form.weightActual) {
          this.form.weightContract = this.form.weightActual
          if (ChargeUtils.getChargeWeightValueType(true) === 1) {
            await this.refreshWeightCharge(this.form, this.form.weightContract)
          }
        }
      })
    },
    async cubageContractChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 1) {
        await this.refreshCubageCharge(this.form, this.form.cubageContract)
      }
      await SEUtils.changeQWCRule(async() => {
        if (this.form.cubageActual !== this.form.cubageContract) {
          this.form.cubageActual = this.form.cubageContract
          if (ChargeUtils.getChargeWeightValueType(true) === 0) {
            await this.refreshCubageCharge(this.form, this.form.cubageActual)
          }
        }
        this.form.chargeWeight = this.form.cubageContract
      })
    },
    async refreshCubageCharge(job, cubage) {
      const charges = await ChargeUtils.cubageChargesCanUpdate(job)
      if (charges.length > 0) {
        await this.$confirm(this.$t('Message.CubageChangeToRefreshCostBasedOnCubagePrice'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          for (const charge of charges) {
            charge.quantity = cubage
            if (charge.unitPriceIncludeTax) {
              ChargeUtils.calculateTaxAmount(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            } else {
              ChargeUtils.calculateTax(charge, multiply(charge.quantity, Number(charge.unitRate)), Number(charge.taxRate))
            }
          }
          this.context.modifiedData.charges = this.context.modifiedData.charges || []
          mergeArray(this.context.modifiedData.charges, charges)
          this.context.reloadCharge = true
        }).catch(() => {})
      }
    },
    async cubageActualChange() {
      if (ChargeUtils.getChargeWeightValueType(true) === 0) {
        await this.refreshCubageCharge(this.form, this.form.cubageActual)
      }
      await SEUtils.changeQWCRule(null, async() => {
        if (this.form.cubageContract !== this.form.cubageActual) {
          this.form.cubageContract = this.form.cubageActual
          if (ChargeUtils.getChargeWeightValueType(true) === 1) {
            await this.refreshCubageCharge(this.form, this.form.cubageContract)
          }
          this.form.chargeWeight = this.form.cubageActual
        }
      })
    },
    customsBrokerFilter(item, inputVal) {
      if (item.cmpIdx === inputVal) {
        return true
      }
      return item.customsBroker && item.railwayExport && item.active
    },
    showAdvanceTextDialog(title, value, autoUppercase, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.autoUppercase = autoUppercase
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    warehouseNameChangeHandler(warehouseName) {
      if (this.form.warehouseInfo.length === 0) {
        return
      }
      const warehouseInfo = this.form.warehouseInfo[0]
      warehouseInfo.warehouseName = warehouseName
      const w = this.warehouseNameList.find(item => item.warehouseName === warehouseName)
      if (w) {
        warehouseInfo.warehouseContactTel = w.warehouseContactTel
        warehouseInfo.warehouseContact = w.warehouseContact
        warehouseInfo.warehouseAddress = w.warehouseAddress
        warehouseInfo.mapFile = w.mapFile
        if (w.remarks) {
          warehouseInfo.remarks = w.remarks
        }
      } else {
        warehouseInfo.warehouseContactTel = ''
        warehouseInfo.warehouseContact = ''
        warehouseInfo.warehouseAddress = ''
        warehouseInfo.mapFile = ''
        warehouseInfo.remarks = ''
      }
      this.pm.addWarehouseToModifiedSet(warehouseInfo)
    },
    /**
     * 拼箱主票直接新增拼箱分票
     */
    async btnCreateClickHandler() {
      const job = this.form
      if (!job.jobNo) {
        throw new ErrorTip(this.$t('Message.TheMasterBillBusinessNumberHasNotBeenGeneratedPleaseSaveTheTheMasterBillFirst'))
      }
      if (!await SecurityUtil.canOPEditWithAlert(job)) {
        return
      }
      this.ticketDialog.value = 1
      this.ticketDialog.visible = true
    },
    toAddTicket() {
      this.pm.selectWindowHandler(this.ticketDialog.value)
      this.ticketDialog.visible = false
    },
    /**
     * 编辑选择的拼箱分票
     */
    btnLcLEditClickHandler() {
      if (this.selectedRow) {
        this.$emit('selectJob', this.selectedRow.uuid)
      } else {
        throw new ErrorTip(this.$t('common.tips.hasOneAtleast'))
      }
    },
    /**
     * 加入小票
     */
    async btnImportLclClickHandler(event) {
      if (!await SecurityUtil.canOPEditWithAlert(this.form)) {
        return
      }
      this.queryRELclDialog.visible = true
    },
    /**
     * 单票删除小票
     */
    async btnRemoveClickHandler() {
      const selectJob = this.selectedRow
      if (!selectJob) {
        throw new ErrorTip(this.$t('Message.PleaseSelectSubBills'))
      }
      if (!this.$checkPermission(['button_REBooking_deleteSmallTicket'])) {
        throw new ErrorTip(this.$t('Message.DeleteSmallTicketTips'))
      }
      if (selectJob.jobState > 0) {
        throw new ErrorTip(this.$t(`[${selectJob.jobNo}]${this.$t('Message.IsNotOperationStatus')}`))
      }
      var loading = getLoading()
      this.context.loading = true
      try {
        await new RailwayExportJob(selectJob).getContainerUsages()
        if (selectJob.quantityActual !== this.pm.getItemLeft(selectJob) || selectJob.weightActual !== this.pm.getWeightLeft(selectJob) ||
          selectJob.cubageActual !== this.pm.getCubageLeft(selectJob)) {
          throw new ErrorTip(this.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeDelete'))
        }
        if (selectJob.containerUsages && selectJob.containerUsages.length > 0) {
          for (const c of selectJob.containerUsages) {
            if (c.container && c.container.jobUuid && c.container.jobUuid === this.form.uuid) {
              throw new ErrorTip(this.$t('Message.TheSubBillHasBeenConsolidatedAndCannotBeDelete'))
            }
          }
        }
        this.context.loading = true
        const res = await validateDelJob({ jobKeys: [selectJob.uuid] })
        this.pm.validateDelJobResultHandler(res.data)
      } finally {
        loading.close()
        this.context.loading = false
      }
    },
    async getSubmitData() {
      try {
        await this.validateForm()
      } catch (err) {
        throw err
      }
      // fba业务
      const fbaJob = this.isFba ? this.fbaJob : null
      return {
        job: this.form,
        seaEQ: this.form.seaEQ,
        delseaEQUuids: this.form.delseaEQUuids,
        containers: this.form.containers,
        delContainerUuids: this.form.delContainerUuids, // 删除的箱子uuid
        delContainerUsageUuids: this.form.delContainerUsageUuids, // 删除的装箱uuid
        fbaJob
      }
    },
    async validateForm() {
      return await this.pm.validateForm()
    },
    endTabHandler() {
      this.pm.fillModel()
    },
    lobChangeHandler() {
      this.form.customJobType = ''
      this.form.secondaryCustomJobType = ''
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
    },
    destinationStationChange(data) {
      this.form.destinationStation = data.value
      // CARGO-40145 修改目的站后同步带出目的国,如果修改后的值为null同步目的国也为null
      if (data.value) {
        const destinationStationCountryCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', data.value, 'countryCode')
        if (destinationStationCountryCode) {
          this.form.destinationCountry = destinationStationCountryCode
        } else {
          this.form.destinationCountry = ''
        }
      } else {
        this.form.destinationCountry = ''
      }
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
    },
    onDepartureStationChange() {
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
    },
    onContainerLoadTypeChange() {
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
      this.customJobTypeList = JobUtils.setCustomJobTypeList(this.form.lob, this.form.containerLoadType, this.form.fba)
    },
    opOfficeChargeHandler() {
      JobUtils.opOfficeChange({ view: this, job: this.form, warehouseCallback: warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }) })
    },
    onCustomJobTypeChange() {
      JobUtils.matchUserPortConfig(this, this.form)
      JobUtils.matchRegionWarehouseMappingConfig(this.form, warehouseId => this.pm.warehouseCmpChangeHandler({ value: warehouseId }))
      this.form.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
    },
    setSecondaryCustomJobTypeFunc() {
      if (this.form.customJobType) {
        this.secondaryCustomJobTypeList = JobUtils.setSecondaryCustomJobTypeList(this.form.customJobType, this.form.lob)
      } else {
        this.secondaryCustomJobTypeList = []
      }
    },
    setCustomJobTypeFunc() {
      this.customJobTypeList = JobUtils.setCustomJobTypeList(this.form.lob, this.form.containerLoadType, this.form.fba)
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.form.opOffice = val
    },
    onCargoTypeChagne() {
      JobUtils.matchUserPortConfig(this, this.form)
    }
  }
}
</script>

<style scoped lang="scss">
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}
</style>
